module.exports = __webpack_public_path__ + "img/newt3.be458bfa.png";